import * as React from 'react';
import { withRouter } from 'react-router-dom';
import './MySparePartsDonut.css';

interface IMySparePartsDonutProps {
  matched: number;
  unmatched: number;
  circleFill?: string;
}

export class MySparePartsDonut extends React.Component<
  IMySparePartsDonutProps,
  {}
> {
  constructor(props: IMySparePartsDonutProps) {
    super(props);
  }

  render() {
    const finalPercentageValues = this.getDonutPercentages(
      this.props.matched,
      this.props.unmatched
    );  
    return (
      <svg width='100%' height='100%' viewBox='0 0 45 45'>
        <circle cx='21' cy='21' r='15.9' fill={this.props.circleFill ? this.props.circleFill : '#fff'} />
        <rect width='2.3' height='2.3' className='darkBlue' x='9.5' y='17.7' />
        <text x='13' y='19.7' className={String(this.props.matched).length <= 3 ? 'fontSizeForLabels' : 'fontSizeForHugeLabels'}>
          {this.props.matched} Matched
        </text>
        <rect width='2.3' height='2.3' className='lightBlue' x='9.5' y='21.5' />
        <text x='13' y='23.5' className={String(this.props.unmatched).length <= 3 ? 'fontSizeForLabels' : 'fontSizeForHugeLabels'}>
          {this.props.unmatched} Unmatched
        </text>
        <circle
          cx='21'
          cy='21'
          r='15.9'
          fill='transparent'
          stroke='#73B7FF'
          strokeWidth='3'
        />
        <circle
          cx='21'
          cy='21'
          r='15.9'
          fill='transparent'
          stroke='#004C97'
          strokeWidth='3'
          strokeDasharray={finalPercentageValues}
          strokeDashoffset='25'
        />
      </svg>
    );
  }

  getDonutPercentages(matched: number, unmatched: number) {
    return (
      (matched * 100) / (matched + unmatched) +
      ' ' +
      (unmatched * 100) / (matched + unmatched)
    );
  }
}

export default withRouter(MySparePartsDonut as any);
